import React, { FC, useMemo } from 'react';
import zxcvbn from 'zxcvbn';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import classes from './PasswordStrengthMeter.module.less';
import Text from '../Text';
import PasswordStrengthIndicator from '../PasswordStrengthIndicator';

type PasswordStrengthMeterProps = {
  password: string;
  // Miernik w ramce na płótnie („Ustaw hasło”) — ciemny napis zamiast jasnego na szarą ścianę
  onLinen?: boolean;
};
const PasswordStrengthMeter: FC<PasswordStrengthMeterProps> = ({ password, onLinen }) => {
  const { t } = useTranslation('common');
  const { score } = useMemo(() => zxcvbn(password), [password]);

  return (
    <div className={classes.container}>
      <PasswordStrengthIndicator score={score} />
      <Text className={classNames(classes.strengthText, { [classes.onLinen]: onLinen })}>
        {t(`passwordStrength.levels.${score}`)}
      </Text>
    </div>
  );
};

export default PasswordStrengthMeter;
